import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  return <nav className="sticky top-0 z-50 bg-[#0B0C10]/90 backdrop-blur-sm border-b border-[#00E5FF]/10" data-id="element-116">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-117">
        <div className="flex items-center justify-between h-16" data-id="element-118">
          <div className="flex items-center" data-id="element-119">
            <div className="flex-shrink-0" data-id="element-120">
              <h1 className="text-2xl font-bold font-['Orbitron'] bg-gradient-to-r from-[#00E5FF] to-[#B721FF] text-transparent bg-clip-text" data-id="element-121">
                NEXORAQ
              </h1>
            </div>
          </div>
          <div className="hidden md:block" data-id="element-122">
            <div className="ml-10 flex items-baseline space-x-8" data-id="element-123">
              <a href="#process" className="text-[#F5F5F5] hover:text-[#00E5FF] transition-colors px-3 py-2 text-sm font-medium" data-id="element-124">
                Process
              </a>
              <a href="#why-us" className="text-[#F5F5F5] hover:text-[#00E5FF] transition-colors px-3 py-2 text-sm font-medium" data-id="element-125">
                Why Us
              </a>
              <a href="#services" className="text-[#F5F5F5] hover:text-[#00E5FF] transition-colors px-3 py-2 text-sm font-medium" data-id="element-126">
                Services
              </a>
              <a href="#about" className="text-[#F5F5F5] hover:text-[#00E5FF] transition-colors px-3 py-2 text-sm font-medium" data-id="element-127">
                About
              </a>
              <button className="bg-gradient-to-r from-[#00E5FF] to-[#B721FF] text-[#0B0C10] font-medium px-5 py-2 rounded-lg hover:shadow-lg hover:shadow-[#00E5FF]/20 transition-all" data-id="element-128">
                Contact
              </button>
            </div>
          </div>
          <div className="md:hidden" data-id="element-129">
            <button onClick={() => setIsOpen(!isOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-[#F5F5F5] hover:text-[#00E5FF] focus:outline-none" data-id="element-130">
              {isOpen ? <X size={24} data-id="element-131" /> : <Menu size={24} data-id="element-132" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isOpen && <div className="md:hidden bg-[#0B0C10]/95 backdrop-blur-lg border-b border-[#00E5FF]/10" data-id="element-133">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-134">
            <a href="#process" className="block px-3 py-2 text-base font-medium text-[#F5F5F5] hover:text-[#00E5FF]" onClick={() => setIsOpen(false)} data-id="element-135">
              Process
            </a>
            <a href="#why-us" className="block px-3 py-2 text-base font-medium text-[#F5F5F5] hover:text-[#00E5FF]" onClick={() => setIsOpen(false)} data-id="element-136">
              Why Us
            </a>
            <a href="#services" className="block px-3 py-2 text-base font-medium text-[#F5F5F5] hover:text-[#00E5FF]" onClick={() => setIsOpen(false)} data-id="element-137">
              Services
            </a>
            <a href="#about" className="block px-3 py-2 text-base font-medium text-[#F5F5F5] hover:text-[#00E5FF]" onClick={() => setIsOpen(false)} data-id="element-138">
              About
            </a>
            <button className="w-full mt-3 bg-gradient-to-r from-[#00E5FF] to-[#B721FF] text-[#0B0C10] font-medium px-5 py-2 rounded-lg hover:shadow-lg hover:shadow-[#00E5FF]/20 transition-all" data-id="element-139">
              Contact
            </button>
          </div>
        </div>}
    </nav>;
};